import { Commit, ActionTree } from 'vuex';
import { State } from '@/store/modules/mobile/mobileCommonState/mobileCommon.store';
import graphQl from '@/services/graphQl';
import { AxiosResponse } from 'axios';

const actions: ActionTree<State, any> = {
  async GET_CRASH_STATS_META(
    context: { commit: Commit },
    params: {
      serviceIds: Array<String>;
      duration: {
        start: String;
        end: String;
        step: String;
      };
      os: Array<String>;
      versionId: Array<String>;
      teamId: String;
    }
  ) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('queryGetDashCrashStats')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.crashesKPIs;
        } else return {};
      });
  },
  async GET_PERFORMANCE_STATS_META(
    context: { commit: Commit },
    params: {
      serviceIds: Array<String>;
      duration: {
        start: String;
        end: String;
        step: String;
      };
      os: Array<String>;
      versionId: Array<String>;
      teamId: String;
    }
  ) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('queryGetDashPerformanceStats')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.performanceKPIs;
        } else return {};
      });
  },
  async GET_DEVICE_USAGE_META(
    context: { commit: Commit },
    params: {
      serviceIds: Array<String>;
      duration: {
        start: String;
        end: String;
        step: String;
      };
      os: Array<String>;
      versionId: Array<String>;
      teamId: String;
    }
  ) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('queryGetDeviceUsageStats')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.usagesInfoForMobileDashboard;
        } else return {};
      });
  },
  async GET_USAGE_KPI_META(
    context: { commit: Commit },
    params: {
      serviceIds: Array<String>;
      duration: {
        start: String;
        end: String;
        step: String;
      };
      os: Array<String>;
      versionId: Array<String>;
      teamId: String;
    }
  ) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('queryGetUsageKpisStats')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.usagesInfoForMobileDashboard;
        } else return {};
      });
  }
};

export default actions;
